
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link/[link]",
      function () {
        return require("private-next-pages/link/[link].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link/[link]"])
      });
    }
  